import { Exclude, Expose, Type } from 'class-transformer';
import { PersonnelModel } from './personnel.model';
import {
  AreaUnit,
  BaseModel,
  CollateralPropertyCompletionStatus,
  CollateralPropertyTenure,
  CollateralPropertyType,
  CollateralPropertyUsage,
  DATEPICKER,
  ToStartOfLocalDateString,
} from '@core/data-access';
import { AddressModel } from '@core/address';
import { Default } from '@core/util';

@Exclude()
export class AuthorizedPersonnelModel extends PersonnelModel {
  @Expose({ toClassOnly: true }) preferredContactTime!: string[];
}

@Exclude()
export class AboutYourBusinessFinancialRequired extends BaseModel {
  @Expose() product!: string;

  @Expose() amountRequired!: number;

  @Expose() tenure!: number;

  @Expose() @Type(() => AuthorizedPersonnelModel) keyPersonnels!: AuthorizedPersonnelModel[];
}

@Exclude()
export class CollateralPropertyModel extends BaseModel {
  /**
   * Primary ID
   *
   * Null when create
   */
  @Expose()
  @Type(() => Number)
  @Default(null)
  id!: number | null;

  @Expose() collateralOwner!: string;

  @Expose()
  @Type(() => Number)
  purchasePrice!: number;

  @Expose()
  @Default(null)
  purchaseDate!: string | null;

  @Expose()
  @ToStartOfLocalDateString(DATEPICKER.PATTERN)
  @Default(null)
  purchaseDateOnly!: string | null;

  @Expose()
  @Type(() => AddressModel)
  address!: AddressModel;

  @Expose()
  @Type(() => AddressModel)
  @Default([])
  addresses!: AddressModel[];

  @Expose() propertyLandTitleDetails!: string;

  @Expose() propertyType!: CollateralPropertyType;

  @Expose() propertySubType!: string;

  @Expose()
  @Default(null)
  buildInArea!: string | null;

  @Expose()
  buildInAreaUnit!: AreaUnit;

  @Expose()
  @Default(null)
  landArea!: string | null;

  @Expose()
  landAreaUnit!: AreaUnit;

  @Expose() completionStatus!: CollateralPropertyCompletionStatus;

  @Expose()
  @Default(null)
  expectedTOP!: string | null;

  @Expose()
  @ToStartOfLocalDateString(DATEPICKER.PATTERN)
  @Default(null)
  expectedTOPOnly!: string | null;

  @Expose()
  @Default(null)
  completionDate!: string | null;

  @Expose()
  @ToStartOfLocalDateString(DATEPICKER.PATTERN)
  @Default(null)
  completionDateOnly!: string | null;

  @Expose()
  @Default(null)
  lastRenovationDate!: string | null;

  @Expose()
  @ToStartOfLocalDateString(DATEPICKER.PATTERN)
  @Default(null)
  lastRenovationDateOnly!: string | null;

  @Expose()
  @Type(() => Number)
  @Default(null)
  renovationCost!: number | null;

  @Expose() tenure!: CollateralPropertyTenure;

  @Expose()
  @Default(null)
  leaseWEF!: string | null;

  @Expose()
  @ToStartOfLocalDateString(DATEPICKER.PATTERN)
  @Default(null)
  leaseWEFOnly!: string | null;

  @Expose() nameOfExistingRegisteredOwner!: string;

  @Expose() nameOfProposedRegisteredOwner!: string;

  @Expose() purpose!: string;

  @Expose()
  @Type(() => Number)
  cpfUtilisedAmount!: number;

  @Expose()
  @Type(() => Number)
  outstandingAmount!: number;

  @Expose() usage!: CollateralPropertyUsage;

  @Expose()
  @Type(() => Number)
  income!: number;
}
